import settings from '@nobia/zeus-components/lib/settings'
import magnet from './magnet/monthsToPay'
import marbodal from './marbodal/monthsToPay'
import invita from './invita/monthsToPay'
import sigdal from './sigdal/monthsToPay'
import norema from './norema/monthsToPay'
import novart from './novart/monthsToPay'

const brands = {
  magnet,
  marbodal,
  invita,
  sigdal,
  norema,
  novart,
}

export const lowDeposit = brands[settings.brand].lowDeposit
export const highDeposit = brands[settings.brand].highDeposit
export const showFinance = brands[settings.brand].showFinance
export const hasMonthlyPayment = brands[settings.brand].hasMonthlyPayment
export const hasFullVersion = brands[settings.brand].hasFullVersion
export const hasMagnetSimplifiedVersion = brands[settings.brand].hasMagnetSimplifiedVersion
export const financeOptions = brands[settings.brand].financeOptions
export const showBada = brands[settings.brand].showBada
export const ifcDepositFactors = brands[settings.brand].ifcDepositFactors
export const ifcThreeYearMinSpend = brands[settings.brand].ifcThreeYearMinSpend
const INTEREST_FREE_PAYMENT =
  financeOptions.length > 1 ? financeOptions[1].id : ''

const getMagnetDeposit = (sum, months, financeId) => {
  if (financeId === INTEREST_FREE_PAYMENT) {
    return ifcDepositFactors[months.months] * sum;
  } else if (sum < 10000) return lowDeposit

  return sum * 0.1;
}

export const getDeposit = (sum, months, financeId) => {
  if (settings.brand === 'magnet') return getMagnetDeposit(sum, months, financeId);
  let deposit = lowDeposit
  if (sum >= 10000) {
    deposit = highDeposit
  }
  return deposit
}

export const getMonthlyPaymentShortVersion = (sum) => {
  let monthlyCost = 0

  const installmentPaymentOptions = financeOptions.find(option => option.id === "installmentPayment");
  const loanOptions = financeOptions.find(option => option.id === "loan");


  if (sum > 100000 && loanOptions) {
    monthlyCost = (sum * (loanOptions.interestAPR/100) + sum) / loanOptions.monthsToPay[0].months + loanOptions.administrativeFee
  } else if (sum <= 100000 && installmentPaymentOptions) {
    monthlyCost = sum / installmentPaymentOptions.monthsToPay[0].months + installmentPaymentOptions.administrativeFee 
  } else {
    monthlyCost = 0
  }

  return Math.round(monthlyCost * 100) / 100
}


export const getMonthlyPayment = (sum, monthlyPayment, financeId) => {
  const { repaymentFactor, months } = monthlyPayment
  const deposit = getDeposit(sum, monthlyPayment, financeId)
  const totalAmountPayable = sum - deposit
  let monthlyCost = 0

  if (repaymentFactor === 0) {
    monthlyCost = totalAmountPayable / months
  } else {
    monthlyCost = totalAmountPayable * repaymentFactor
  }

  return Math.round(monthlyCost * 100) / 100
}

export const getTotalPayment = (sum, monthlyPayment, financeId) => {
  const payment = getMonthlyPayment(sum, monthlyPayment, financeId)
  const totalInterestPayment = payment * monthlyPayment.months
  return totalInterestPayment
}

const getAvailableInterestFreeMonths = (sum, months) => {
  if (settings.brand === 'magnet') {
    if (sum < ifcThreeYearMinSpend) {
      return months.filter(option => option.months === 24 || option.months === 60)
    }
    return months.filter(
      option => option.months === 24 || option.months === 36 || option.months === 60
    )
  }

  return months.filter(option => option.months === (sum > 10000 ? 60 : 36))
}

export const filterMonthsToPay = (sum, months, financeId) =>
  financeId === INTEREST_FREE_PAYMENT
    ? getAvailableInterestFreeMonths(sum, months)
    : months

export const getYearsToPay = ({ months }) => months / 12
